module.exports = __webpack_public_path__ + "img/ai-input-csv.d9ec947b.svg";